export default __webpack_public_path__ + "static/media/Tracey M.93121eec.jpeg";